import { formatSecondsToDurationLabel } from "@memorang/helpers/common";

export const emptyStates = {
	progress: {
		title: "No Progress Data Available",
		subtitle: "As you study your progress will show up here",
		cta: "STUDY",
	},
	insights: {
		title: "No insights available yet",
		subtitle:
			"As you complete more challenges, insights will be generated here",
		cta: "START CHALLENGE",
	},
};

export const purchaseUrlMap: Record<
	number,
	{
		purchaseUrl: string;
	}
> = {
	66: {
		purchaseUrl: "https://www.therapyed.com/npte-exam/npte-study-guide/",
	},
	67: {
		purchaseUrl: "https://www.therapyed.com/pta-exam/pta-study-guide/",
	},
	68: {
		purchaseUrl: "https://www.therapyed.com/slp-praxis-exam/slp-study-guide/",
	},
	69: {
		purchaseUrl:
			"https://www.therapyed.com/nbcot-cota-exam/nbcot-cota-study-guide/",
	},
	70: {
		purchaseUrl:
			"https://www.therapyed.com/nbcots-otr-exam/nbcots-otr-study-guide/",
	},
};

export const drawerWidths = {
	collapsed: 80,
	expanded: 280,
};

export const resumeSessionInfoDialogConfig = ({
	examName,
	totalTime,
	timeElapsed,
}: {
	examName: string;
	totalTime: number;
	timeElapsed: number;
}) => {
	const timeRemaining = totalTime - timeElapsed;
	const timeRemainingLabel = formatSecondsToDurationLabel(timeRemaining);
	return {
		title: "Resume exam",
		body: `You are about to resume **${examName}**. You have **${timeRemainingLabel}** remaining.`,
	};
};
